<rav-modal revealSize="large" [modalTitle]="modalTitle" [modalId]="'version'">
  <h6>Download and restore feature available up to the last major version.</h6>
  <div class="table-container" data-cy="version">
    <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows mat-elevation-z8 class="no-hover-table">
      <ng-container *ngFor="let column of tableConfig.columns" [matColumnDef]="column.key">
        <mat-header-cell *matHeaderCellDef>
          <span mat-sort-header>
            {{ column.header ? (column.header | titlecase) : (column.key | snakeCaseToHuman | titlecase) }}
          </span>
        </mat-header-cell>
        <mat-cell *matCellDef="let row; let i = dataIndex" data-cy="table-cell">
          <ng-container *ngIf="column.key !== 'action'">
            {{ row[column.key] | tableCell: column.key }}
          </ng-container>
          <ng-container *ngIf="column.key === 'action'">
            <div class="grid-x table-container__action">
              <div *ngIf="row['canDownload']">
                <div class="cell small-6">
                  <a class="cell__download" (click)="download(row)"><i class="fa fa-download"></i> Download</a>
                </div>
              </div>
              <div *ngIf="row['canRestore']">
                <div class="cell small-6">
                  <a class="cell__restore" (click)="restore(row)"><i class="fa fa-undo"></i> Restore</a>
                </div>
              </div>
            </div>
          </ng-container>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="columnsToDisplay"></mat-header-row>
      <mat-row
        class="table-container__row"
        *matRowDef="let row; columns: columnsToDisplay; let i = dataIndex"
      ></mat-row>
    </table>
    <mat-paginator
      class="background"
      [length]="paginatorLength$ | async"
      [pageSize]="tableConfig.fixedPageSize"
      [hidePageSize]="tableConfig.fixedPageSize"
      showFirstLastButtons
    ></mat-paginator>
  </div>
</rav-modal>
